

import crypto from 'crypto'

const key = crypto
    .createHash('sha512')
    .update(process.env.REACT_APP_SECRET_KEY_EN)
    .digest('hex')
    .substring(0, 32)

const encryptionIV = crypto
    .createHash('sha512')
    .update(process.env.REACT_APP_SECRET_IV)
    .digest('hex')
    .substring(0, 16)

const EncryptData = (data: string) => {
    const cipher = crypto.createCipheriv(process.env.REACT_APP_ENCRYPTION_METHOD, key, encryptionIV)
    return Buffer.from(cipher.update(data, 'utf8', 'hex') + cipher.final('hex')).toString('base64')
}

const DecryptData = (data: string) => {
    const buff = Buffer.from(data, 'base64')
    const decipher = crypto.createDecipheriv(process.env.REACT_APP_ENCRYPTION_METHOD, key, encryptionIV)
    return (decipher.update(buff.toString('utf8'), 'hex', 'utf8') + decipher.final('utf8'))
}

const roundToTwo = (value: number, decimals = 2): number => (Number(Math.round(parseFloat(value.toString() + 'e' + decimals)) + 'e-' + decimals));
const typeMoney: { [key: string]: string } = {
    '¢': 'es-CR',
    'U$': 'en-US'
}
const typeMoney2: { [key: string]: string } = {
    '¢': 'CRC',
    'U$': 'USD'
}

const formatCurrency = (currency: string = 'U$', value: number) => new Intl.NumberFormat(typeMoney[currency.trim()], { style: 'currency', currency: typeMoney2[currency.trim()], currencyDisplay: 'symbol' }).format(value);

const GetResumenRate = ({ plan, lstRates, lstCoverageExt, idDiscount, catQuotas, nQuotas, sumInsured }: IPropsResumenRate) => {
    let coveragesDetail: Array<IRatesTable> = [];    
    const currency = plan.moneda.trim();

    let financing: number = 0;
    let desc = 0;
    let taxAcum = 0;
    let cobBonusDE = 0;

    lstRates.map((rate: IRates) => {
        let nameCover = lstCoverageExt.find(x => x.idCob === rate.idCob);
        let taxPercentage = GetTaxPercentage(nameCover ?? {} as ICoveragesExt, plan)
        if (nameCover !== undefined) {
            let insuredMount = parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1);
            let det: IRatesTable = {
                idcob: rate.idCob,
                name: nameCover.nombre,
                insured: formatCurrency(currency, insuredMount),
                sa: rate.sa,
                value: formatCurrency(currency, parseFloat(rate.sa))
            };
            coveragesDetail.push(det);

            if (nameCover.bImpuesto1) {     
                taxAcum = roundToTwo(taxAcum +  roundToTwo(parseFloat(rate.prima) * roundToTwo((GetTaxPercentage(nameCover, plan).tax1 / 100)))); 
                cobBonusDE = roundToTwo(cobBonusDE + parseFloat(rate.prima))              
            }
            //bonusTax =   bonusTax + insuredMount;

            let porcenDescount = 0;
            if (rate.descuentos.length > 0) {
                let descAp = rate.descuentos.find((x: any) => x.codigoDescuento === idDiscount)
                if (descAp !== undefined) {
                    porcenDescount = descAp.porcentaje;
                }
                else {
                    porcenDescount = rate.descuentos[0].porcentaje;
                }
            }

            if (porcenDescount > 0) {
                let prima = parseFloat(rate.prima);
                desc = desc + roundToTwo((roundToTwo(prima) + roundToTwo((prima * rate.pRecargo) / 100)) * (porcenDescount / 100))
            }
        }
    });

    
    let rightEmission: number = roundToTwo(cobBonusDE * (plan.porcentajeGasto / 100));
    if (rightEmission < plan.gastoMontoMinimo)
        rightEmission = plan.gastoMontoMinimo;
    if (rightEmission > plan.gastoMontoMaximo)
        rightEmission = plan.gastoMontoMaximo;

    let taxFinancing = plan.intereses ?? undefined;

    let bonus = lstRates.reduce((accumulator, x) => {
        const primaCalculada = roundToTwo(parseFloat(x.prima)) + roundToTwo((parseFloat(x.prima) * x.pRecargo) / 100);
        accumulator += primaCalculada;
        return roundToTwo(accumulator);
    }, 0);

    let bonusDE = roundToTwo(cobBonusDE - desc);
    let bonus2 = roundToTwo(bonus - desc);

    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === (nQuotas === '' ? 0 : parseInt(nQuotas)));
        if (taxP !== undefined)
            financing = roundToTwo((bonus2 * (parseFloat(taxP.porcentajeInteres) / 100)));
    }



    let tax = taxAcum;
    let total = roundToTwo(bonus2 + tax + financing + rightEmission);

    let catBonusFrecuenia: Array<ICatalog> = catQuotas.map((x: ICatalog) => {
        return {
            text: x.text,
            value: formatCurrency(currency, (bonus2 + tax + GetFinancing(taxFinancing, bonus2, x.value) + rightEmission) / parseInt(x.value))
        } as ICatalog
    })

   

    let result: IRatesResumen = {
        coveragesDetail: coveragesDetail,
        bonus: bonus,
        desc: desc,
        bonus2: bonus2,
        tax: tax,
        financing: financing,
        total: total,
        bonusDE: bonusDE,
        rightEmission: rightEmission,

        bonusStr: formatCurrency(currency, bonus),
        descStr: formatCurrency(currency, desc),
        bonus2Str: formatCurrency(currency, bonus2),
        taxStr: formatCurrency(currency, tax),
        financingStr: formatCurrency(currency, financing),
        totalStr: formatCurrency(currency, total),

        bonusAnnual: '',
        bonusSemester: '',
        bonusQuarterly: '',
        bonusMonthly: '',
        bonusFrecuencia: 0,
        bonusFrecuenciaStr: formatCurrency(currency, (bonus2 + tax + GetFinancing(taxFinancing, bonus2, nQuotas) + rightEmission) / parseInt(nQuotas)),

        rightEmissionsStr: formatCurrency(currency, rightEmission),
        bonusfrequency: catBonusFrecuenia,
        sumInsured: sumInsured,
        sumInsuredStr: formatCurrency(currency, roundToTwo(parseFloat(sumInsured)))
    }
    return result;
}

const GetFinancing = (taxFinancing: any, bonus: number, quotas: string = '') => {
    let financing = 0
    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === (quotas === '' ? 0 : parseInt(quotas)));
        if (taxP !== undefined)
            financing = roundToTwo((bonus * (parseFloat(taxP.porcentajeInteres) / 100)));
    }
    return financing;
}

const GetTaxPercentage = (coverage: ICoveragesExt, plan: IPlanConfig) => {
    let tax = { tax1: 0, tax2: 0 }
    if (coverage.bImpuesto1) {
        if (coverage.pImpuesto1 !== undefined)
            tax.tax1 = coverage.pImpuesto1;
        else
            tax.tax1 = plan.impuestos.interes
    }
    if (coverage.bImpuesto2) {
        if (coverage.pImpuesto2 !== undefined)
            tax.tax2 = coverage.pImpuesto2;
        else
            tax.tax2 = plan.impuestos.interes2
    }
    return tax;
}

const CalculateAge = (date: Date) => {

    const today = new Date();
    const birthDate = new Date(date);

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

const GetNewGuid = (type: number = 0) => {
    if (type === 1)
        return 'xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r: number = Math.random() * 16 | 0;
            const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r: number = Math.random() * 16 | 0;
        const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export {
    EncryptData,
    DecryptData,
    GetResumenRate,
    CalculateAge,
    formatCurrency,
    GetNewGuid
}